import Element from '../ui/Element';
import mixin from '../privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';


/**
 * @mixin HiddenCollapsedElement
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @description
 *  The `HiddenCollapsedElement` [mixin](https://support.wix.com/en/article/velo-about-mixins) provides properties, functions, and event handlers that elements can inherit and use.
 *  
 *  > **Note:** Mixins are not elements. You cannot add mixins to a page in the Editor like other `$w` elements, and mixins are not meant to be used directly 
 *  in your code. 
 * 
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 */
class HiddenCollapsedElement extends Element {}

mixin(HiddenCollapsedElement.prototype, HiddenCollapsedMixin.prototype);

export default HiddenCollapsedElement;
